import script from "./vmsOrgRelationshipManager.vue?vue&type=script&lang=js"
export * from "./vmsOrgRelationshipManager.vue?vue&type=script&lang=js"

import "./vmsOrgRelationshipManager.vue?vue&type=style&index=0&id=74b08515&scoped=true&lang=css"
import "./vmsOrgRelationshipManager.vue?vue&type=style&index=1&id=74b08515&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b08515"]])

export default __exports__